import type { ExpectedProgressStatus } from '@bigint-project/core';

import { PROGRESS_STATUS_LABEL, progressStatusBadgeClass } from './format.js';

export interface ProgressStatusBadgeProps {
  readonly status: ExpectedProgressStatus;
  /** 接在狀態文字後面的補充（例如「· 預期 62%」）。 */
  readonly detail?: string;
  readonly title?: string;
  readonly testId?: string;
}

/** 預期進度狀態徽章（看板卡片、工時網格列尾共用）。 */
export function ProgressStatusBadge({
  status,
  detail,
  title,
  testId,
}: ProgressStatusBadgeProps): React.JSX.Element {
  return (
    <span
      data-testid={testId}
      title={title}
      className={`rounded px-1.5 py-0.5 text-xs ${progressStatusBadgeClass(status)}`}
    >
      {PROGRESS_STATUS_LABEL[status]}{detail === undefined ? '' : ` ${detail}`}
    </span>
  );
}
